import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";
import { Globe } from "lucide-react";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: "en-US", name: "English", flag: "🇺🇸" },
    { code: "sk-SK", name: "Slovensky", flag: "🇸🇰" },
    { code: "de-DE", name: "Deutsch", flag: "🇩🇪" },
    { code: "ru-RU", name: "Русский", flag: "🇷🇺" },
    { code: "ua-UA", name: "Українська", flag: "🇺🇦" },
  ];

  const changeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
  };

  const currentLanguage =
    languages.find((lang) => lang.code === i18n.language) || languages[0];

  return (
    <div className="relative group">
      <Button variant="ghost" size="sm" className="flex items-center space-x-2">
        <Globe className="h-4 w-4" />
        <span className="hidden md:inline">{currentLanguage.name}</span>
      </Button>

      <div className="absolute right-0 mt-2 w-48 bg-lightCream border border-warmOrange/30 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        <div className="py-1">
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => changeLanguage(language.code)}
              className={`w-full px-4 py-2 text-left text-sm hover:bg-cream/50 transition-colors flex items-center space-x-3 ${
                i18n.language === language.code
                  ? "bg-sage/20 text-teal"
                  : "text-foreground"
              }`}
            >
              <span className="text-lg mr-2">{language.flag}</span>
              <span>{language.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
